export default "__VITE_ASSET__B6sjwq8w__"